import { throttle } from 'underscore';

const isSameRecord = (
    { name: name1, nickname: nickname1, prizeDisplayName: prizeDisplayName1, timeAwarded: timeAwarded1 },
    { name: name2, nickname: nickname2, prizeDisplayName: prizeDisplayName2, timeAwarded: timeAwarded2 }
) => name1 === name2 && nickname1 === nickname2 && prizeDisplayName1 === prizeDisplayName2 && timeAwarded1 === timeAwarded2;

const getIntersectionLength = (next, prev) => {
    if (!prev.length) {
        return 0;
    }
    const head = prev[0];
    const offset = next.findIndex(value => isSameRecord(value, head));
    if (offset === -1) {
        return 0;
    }
    return next.length - offset;
};

const merge = (next, prev, intersectionLength) => [
    ...next.slice(-intersectionLength - 1),
    ...prev.slice(intersectionLength, next.length <= prev.length ? -1 : undefined)
].map(value => ({ ...value }));

export const buildWinnersUpdater = (dispatch, initialWinners) => {
    let currentWinners = initialWinners;

    const updateWinnersThrottled = throttle((winners) => {
        const length = getIntersectionLength(winners, currentWinners);
        if (currentWinners.length === winners.length && winners.length === length) {
            return;
        }
        currentWinners = merge(winners, currentWinners, length);
        dispatch(currentWinners);
        updateWinnersThrottled(winners);
    }, 700);

    return updateWinnersThrottled;
};

